export const MASTERCLASS_SOURCE_ADMIN = "admin";
export const MASTERCLASS_SOURCE_SERIES_Y_REPETICIONES =
  "series-y-repeticiones";

/**
 * Leads captured on /opciones. They share the masterclassLeads table but run
 * their own 3-step drip, so masterclass sends and backfills exclude them.
 */
export const OPCIONES_SOURCE = "opciones";
